/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Effect from './Effect';
import NodeTransformData from './NodeTransformData';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Effect for moving a node to a static position. */
@cc._decorator.ccclass
export default class MoveNodeEffect extends Effect
{
    /** The node to be moved and the static transform for its destination. */
    @property({ type: [NodeTransformData], visible: true })
    private _nodes: NodeTransformData[] = [];
    public get NodeTransforms(): NodeTransformData[] { return this._nodes; }

    /** Duration of the tween. */
    @property({ type: cc.Float, visible: true })
    private _duration: number = 0.0;

    /** Mutator for the duration of the tween. */
    public set Duration(value: number) { this._duration = value; }

    /** @hidden */
    private _runningActions: cc.Action[] = [];

    /** @hidden */
    protected update(): void
    {
        if (!this.IsCurrentState()) { return; }

        this.movementFinishedHandler();
    }

    /** @hidden */
    private movementFinishedHandler(): void
    {
        for (let action of this._runningActions)
        {
            if (!action.isDone())
            {
                return;
            }
        }

        this.complete();
    }

    /** Executes the tween. */
    protected trigger = (): void =>
    {
        for (let nodeData of this._nodes)
        {
            nodeData.Node.stopAllActions();

            let actionInterval: cc.ActionInterval = cc.moveTo(
                this.dtModRef.Value.Reduce(this._duration), nodeData.Transform);
            let action: cc.Action = nodeData.Node.runAction(actionInterval);

            this._runningActions.push(action);
        }
    }

    /** Sets the internal state to that of a completed effect. */
    protected complete(): void
    {
        super.complete();

        this._runningActions = [];
    }

    /** Stops the in-progress effect or the next trigger. */
    public Stop(): void
    {
        super.Stop();

        this.complete();
    }
}
